// @flow
import { StyledRowSpecificErrorMessage } from '@src/common-utils/styledComponents';
import React from 'react';

export const StyledRowSpecificErrorMessageContainer = ({ message }) => (
  <StyledRowSpecificErrorMessage negative={true}>
    <StyledRowSpecificErrorMessage.Header>{message}</StyledRowSpecificErrorMessage.Header>
  </StyledRowSpecificErrorMessage>
);
